export default "__VITE_ASSET__bb960e53__"